var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('elsa-badge',{attrs:{"value":_vm.value,"help":_vm.tasonNimi}})}
var staticRenderFns = []

export { render, staticRenderFns }